import api from './../index';

export const getPdf = async docId => {
  const res = await api();
  return res.get(`document/getPdf/${docId}`).then(res => {
    return res.data;
  });
};
